module.exports = __webpack_public_path__ + "img/icon-help.ac7d3a23.svg";